import { Select2Data } from "src/app/shared/ui/forms/inputs/oops-select2";

export class ProfileRowView {
    public profileType: string;
    public profileTypeCodes: Select2Data[]
    public codes: string[]
    public sortSequence: boolean = false;
    public duplicated: boolean = false;
}